import React, { PureComponent, Fragment } from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import ShowcaseUpload from './shocase-upload';
import ShowcaseItem from './showcase-item';
const TIPS1 = '请设置图片上传';
const TIPS2 = '请设置图片上传';
const TIPS3 = '请设置图片上传';
const TIPS4 = '请设置图片上传';
export default class ShowcaseLayout extends PureComponent<any> {
    state = { index: 0 };
    onSelectItem = (index) => {
        this.setState({ index: index });
    };
    renderOne = () => {
        const { value } = this.props;
        const { index } = this.state;
        return (
            <div className="showcase-content">
                <div className=" showcase-container" style={{ flexDirection: 'column' }}>
                    <div className="flex-row">
                        <ShowcaseUpload
                            style={{ height: 125 }}
                            className={classnames({ active: index === 0 })}
                            onClick={this.onSelectItem.bind(this, 0)}
                            tips={TIPS1}
                            value={get(value, '[0].pic', null)}
                        />
                        <ShowcaseUpload
                            style={{ height: 125 }}
                            className={classnames({ active: index === 1 })}
                            onClick={this.onSelectItem.bind(this, 1)}
                            tips={TIPS1}
                            value={get(value, '[1].pic', null)}
                        />
                    </div>
                    <div className="flex-row">
                        <ShowcaseUpload
                            style={{ height: 125 }}
                            className={classnames({ active: index === 2 })}
                            onClick={this.onSelectItem.bind(this, 2)}
                            tips={TIPS1}
                            value={get(value, '[2].pic', null)}
                        />
                        <ShowcaseUpload
                            style={{ height: 125 }}
                            className={classnames({ active: index === 3 })}
                            onClick={this.onSelectItem.bind(this, 3)}
                            tips={TIPS1}
                            value={get(value, '[3].pic', null)}
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderTwo = () => {
        const { value } = this.props;
        const { index } = this.state;
        return (
            <div className="showcase-content">
                <div className="showcase-container">
                    <ShowcaseUpload
                        style={{ height: 250 }}
                        className={classnames({ active: index === 0 })}
                        onClick={this.onSelectItem.bind(this, 0)}
                        tips={TIPS2}
                        value={get(value, '[0].pic', null)}
                    />
                    <div className="flex-column">
                        <ShowcaseUpload
                            style={{ height: 125 }}
                            className={classnames({ active: index === 1 })}
                            onClick={this.onSelectItem.bind(this, 1)}
                            tips={TIPS1}
                            value={get(value, '[1].pic', null)}
                        />
                        <ShowcaseUpload
                            style={{ height: 125 }}
                            className={classnames({ active: index === 2 })}
                            onClick={this.onSelectItem.bind(this, 2)}
                            tips={TIPS1}
                            value={get(value, '[2].pic', null)}
                        />
                    </div>
                </div>
            </div>
        );
    };
    renderThree = () => {
        const { value } = this.props;
        const { index } = this.state;
        return (
            <div className="showcase-content">
                <div className="showcase-container" style={{ flexDirection: 'column' }}>
                    <ShowcaseUpload
                        style={{ height: 125 }}
                        className={classnames({ active: index === 0 })}
                        onClick={this.onSelectItem.bind(this, 0)}
                        tips={TIPS3}
                        value={get(value, '[0].pic', null)}
                    />
                    <div className="flex-row">
                        <ShowcaseUpload
                            style={{ height: 125 }}
                            className={classnames({ active: index === 1 })}
                            onClick={this.onSelectItem.bind(this, 1)}
                            tips={TIPS1}
                            value={get(value, '[1].pic', null)}
                        />
                        <ShowcaseUpload
                            style={{ height: 125 }}
                            className={classnames({ active: index === 2 })}
                            onClick={this.onSelectItem.bind(this, 2)}
                            tips={TIPS1}
                            value={get(value, '[2].pic', null)}
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderFour = () => {
        const { value } = this.props;
        const { index } = this.state;
        return (
            <div className="showcase-content">
                <div className=" showcase-container">
                    <ShowcaseUpload
                        style={{ height: 250 }}
                        className={classnames({ active: index === 0 })}
                        onClick={this.onSelectItem.bind(this, 0)}
                        tips={TIPS2}
                        value={get(value, '[0].pic', null)}
                    />
                    <div className="flex-column">
                        <ShowcaseUpload
                            style={{ height: 125 }}
                            className={classnames({ active: index === 1 })}
                            onClick={this.onSelectItem.bind(this, 1)}
                            tips={TIPS1}
                            value={get(value, '[1].pic', null)}
                        />
                        <div className="flex-row">
                            <ShowcaseUpload
                                style={{ height: 125 }}
                                className={classnames({ active: index === 2 })}
                                onClick={this.onSelectItem.bind(this, 2)}
                                tips={TIPS4}
                                value={get(value, '[2].pic', null)}
                            />
                            <ShowcaseUpload
                                style={{ height: 125 }}
                                className={classnames({ active: index === 3 })}
                                onClick={this.onSelectItem.bind(this, 3)}
                                tips={TIPS4}
                                value={get(value, '[3].pic', null)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    render() {
        const {
            value,
            uploadAction,
            sourceRoot,
            onChange,
            linkTypes,
            linkTypeMode,
            showStyle,
            selector,
        } = this.props;
        const { index } = this.state;
        return (
            <Fragment>
                {showStyle === '1' && this.renderOne()}
                {showStyle === '2' && this.renderTwo()}
                {showStyle === '3' && this.renderThree()}
                {showStyle === '4' && this.renderFour()}
                <ShowcaseItem
                    selector={selector}
                    items={value}
                    index={index}
                    linkTypes={linkTypes}
                    linkTypeMode={linkTypeMode}
                    item={get(value, `[${index}]`, {})}
                    uploadAction={uploadAction}
                    sourceRoot={sourceRoot}
                    onChange={onChange}
                />
            </Fragment>
        );
    }
}
